import React from 'react';
import { noop } from 'lodash';
import CustomArrow from './CustomArrow';

export const createSliderSettings = ({
    slidesToShow,
    breakpoints,
    afterChange = noop,
    isTouch,
    isInfinite = false,
}) => {
    const sliderSettings = {
        dots: false,
        isInfinite,
        speed: 300,
        arrows: !isTouch,
        useArrows: !isTouch,
        nextArrow: <CustomArrow />,
        prevArrow: <CustomArrow />,
        centerMode: false,
        slidesToShow,
        slidesToScroll: slidesToShow,
        responsive: [],
        afterChange,
        sliderBreakpoints: breakpoints,
    };

    return sliderSettings;
};
